export type ParseLatexStringArrayResult = { ok: true; items: string[] } | { ok: false; error: string };

export function parseLatexStringArray(raw: string): ParseLatexStringArrayResult {
    const trimmed = raw.trim();
    if (trimmed === '') {
        return { ok: true, items: [] };
    }

    let parsed: unknown;
    try {
        parsed = JSON.parse(trimmed);
    } catch {
        return { ok: false, error: 'Value is not valid JSON.' };
    }

    if (!Array.isArray(parsed)) {
        return { ok: false, error: 'Value must be a JSON array.' };
    }

    if (!parsed.every(item => typeof item === 'string')) {
        return { ok: false, error: 'Every array entry must be a string.' };
    }

    return { ok: true, items: parsed };
}

export function serializeLatexStringArray(items: string[]): string {
    const nonEmpty = items.map(s => s.trim()).filter(s => s !== '');
    return JSON.stringify(nonEmpty);
}
